import React, { useState } from 'react';

import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';
import UploadPopup from '../../../../shared-components/upload-popup/UploadPopup';
import { DOC_MESSAGE } from '../../../../config/constant';

const RefundDetails = ({ applicantData }) => {
  const { t } = useTranslation("common", { keyPrefix: "voucherPreview" });
  const data = applicantData?.paymentDetails?.recoveryAccountDetails;
  const [openPopup, setOpenPopup] = useState(false);

  return (
    <>
    <div className="applicantDetailsCard">
      <h3 className="titlePersonalHD marginBottom10">{t("refundDetails.title")}</h3>
      <div className="personalInfo width50">
        {data?.payeeName ? (
          <div className="personalInfoRow">
            <label className="label200">{t("refundDetails.payeeName")}:</label>
            <span
              style={{
                display: 'flex',
                wordBreak: 'break-word', // Break long words
                whiteSpace: 'normal', // Allow wrapping
                maxWidth: '100%', // Ensure it respects container width
              }}
            >
              {data?.payeeName || 'N/A'}
            </span>
          </div>
        ) : null}

        {data?.bankName ? (
          <div className="personalInfoRow">
            <label className="label200">{t("refundDetails.bankName")}:</label>
            <span
              style={{
                display: 'flex',
                wordBreak: 'break-word', // Break long words
                whiteSpace: 'normal', // Allow wrapping
                maxWidth: '100%', // Ensure it respects container width
              }}
            >
              {data?.bankName || 'N/A'}
            </span>
          </div>
        ) : null}

        {data?.ifscCode ? (
          <div className="personalInfoRow">
            <label className="label200">{t("refundDetails.ifscCode")}:</label>
            <span
              style={{
                display: 'flex',
                wordBreak: 'break-word', // Break long words
                whiteSpace: 'normal', // Allow wrapping
                maxWidth: '100%', // Ensure it respects container width
              }}
            >
              {data?.ifscCode || 'N/A'}
            </span>
          </div>
        ) : null}

        {data?.accountNumber ? (
          <div className="personalInfoRow">
            <label className="label200">{t("refundDetails.accountNumber")}:</label>
            <span
              style={{
                display: 'flex',
                wordBreak: 'break-word', // Break long words
                whiteSpace: 'normal', // Allow wrapping
                maxWidth: '100%', // Ensure it respects container width
              }}
            >
              {data?.accountNumber || 'N/A'}
            </span>
          </div>
        ) : null}

        {data?.accountType ? (
          <div className="personalInfoRow">
            <label className="label200">{t("refundDetails.accountType")}:</label>
            <span
              style={{
                display: 'flex',
                wordBreak: 'break-word', // Break long words
                whiteSpace: 'normal', // Allow wrapping
                maxWidth: '100%', // Ensure it respects container width
              }}
            >
              {data?.accountType || 'N/A'}
            </span>
          </div>
        ) : null}

        {(data?.cancelledCheque?.length > 0 || data?.isPhysicalCancelledCheque) ? (
          <div className="personalInfoRow">
            <label className="label200">{t("refundDetails.cancelledCheque")}:</label>
            {data?.isPhysicalCancelledCheque && data?.cancelledCheque?.length === 0 ? (
                <span style={{ fontWeight: 600 }}>{DOC_MESSAGE}</span>
            ) : (
                <Button
                size="large"
                sx={{
                    textTransform: "none",
                    color: "#1A407D",
                    fontWeight: 400,
                    fontSize: "14px",
                    border: `1px solid ${data?.cancelledCheque?.length === 0 ? "#BDBDBD" : "#1A407D"}`,
                    borderRadius: "8px",
                    px: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap:'8px'
                }}
                onClick={() => setOpenPopup(true)}
            >
                <VisibilityIcon sx={{ color: data?.cancelledCheque?.length>0 ? undefined : "#1A407D" }} />
                View
            </Button>
            )}
          </div>
        ) : null}
      </div>
    </div>
    {openPopup && (
        <UploadPopup
        heading="View"
        totalImages={1}
        closePopup={() => setOpenPopup(false)}
        uploadedImage={data.cancelledCheque[0] ? [data.cancelledCheque[0]] : []}
        fieldName={"cancelledCheque"}
        hidePhysicalCopyOption
        dynamicSize={1}
        hideCameraOption={false}
        showDeleteIcon={false}
        />
    )}
    </>
  );
};

export default RefundDetails;
